import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_1W_17_77',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_1w_17_77_usd',
			ARS: 'simple_premium_4w_51890_1w_27770_ars',
			COP: 'simple_premium_4w_157390_1w_77700_cop',
			CLP: 'simple_premium_4w_37690_1w_17770_clp',
		},
		primer: 'prd_x2E1ay0Bxgg0',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 17.77,
			ARS: 27770,
			COP: 77700,
			CLP: 17770,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			ARS: 51890,
			COP: 157390,
			CLP: 37690,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: '7-days', // 'first week'
		explicitTermsIntervalText: '4 weeks',
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.7_days.period_text'), // '1-week'
		footerIntervalText: '4-week', // '4-week',
		updatedTermsPeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
	}),
}
